const generateYearsList = (from: number, to: number = (new Date()).getFullYear()): string[] => {
  if (from > to) return [];
  const arr = new Array(to - from).fill(undefined).map((_year, yearIndex) => `${from + yearIndex}`);
  return [...arr, `${to}`].reverse();
};

export default generateYearsList;
